import { BatchUpdatePayload, Change, EntityName, RequestPayload } from '../types/PayloadTypes';

const FIELD_NAMES = {
	RUN_ID: 'run_id',
	CUSTOM_FIELDS: 'custom_fields'
} as const;

export const buildBasePayload = (runId: string, entityName: EntityName = 'all'): RequestPayload => {
	return {
		scope: {
			conditions: [{ field: FIELD_NAMES.RUN_ID, value: runId }],
			entityName
		},
		changes: []
	};
};

export const addChanges = (payload: RequestPayload, changes: Change[]): RequestPayload => {
	return {
		...payload,
		changes: [...payload.changes, ...changes]
	};
};

export const buildBatchPayload = (
	runIds: string[],
	changes: Change[],
	entityName: EntityName = 'all'
): BatchUpdatePayload => {
	const updates = runIds.map((runId) => {
		const payload = buildBasePayload(runId, entityName);
		return addChanges(payload, changes);
	});

	return { updates };
};

export const createCustomFieldAddChange = (key: string, value: string): Change => {
	return {
		fieldName: FIELD_NAMES.CUSTOM_FIELDS,
		value: [key, value],
		operation: 'add'
	};
};

export const createCustomFieldRemoveChange = (key: string, value: string): Change => {
	return {
		fieldName: FIELD_NAMES.CUSTOM_FIELDS,
		value: [key, value],
		operation: 'remove'
	};
};
